import {
  colorBackgroundAlt,
  colorBackgroundDefault,
  colorContentDefaultInverse,
  colorOutlineSoftest,
  colorStatusAlertBold,
  colorStatusAlertSoftest,
  colorStatusNeutralBold,
  colorStatusNeutralSoftest,
  colorStatusNoticeDefault,
  colorStatusPositiveBold,
  colorStatusPositiveSoftest,
} from '@duxton-web/design-tokens/themes/light';

export const contentConfigStyleVars = {
  '--cc-background-alt': colorBackgroundAlt,
  '--cc-background-default': colorBackgroundDefault,
  '--cc-content-default-inverse': colorContentDefaultInverse,
  '--cc-outline-softest': colorOutlineSoftest,
  '--cc-status-alert-bold': colorStatusAlertBold,
  '--cc-status-alert-softest': colorStatusAlertSoftest,
  '--cc-status-neutral-bold': colorStatusNeutralBold,
  '--cc-status-neutral-softest': colorStatusNeutralSoftest,
  '--cc-status-notice-default': colorStatusNoticeDefault,
  '--cc-status-positive-bold': colorStatusPositiveBold,
  '--cc-status-positive-softest': colorStatusPositiveSoftest,
};

export const contentConfigModalStyle = {
  ...contentConfigStyleVars,
  maxWidth: '96vw',
};
